import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-premiere-trailer',
  templateUrl: './premiere-trailer.component.html',
  styleUrls: ['./premiere-trailer.component.css']
})
export class PremiereTrailerComponent implements OnInit, OnChanges {
  @Input() trailerUrl = '';
  @Input() premiereDetails: any;
  videoUrl: SafeResourceUrl;
  video = '';
  constructor(private _sanitizer: DomSanitizer)
  {
    console.warn(this.trailerUrl);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.trailerUrl) {
      console.warn(this.trailerUrl);
      this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(this.trailerUrl);
    }
  }




  ngOnInit(): void {

  }

}
